export default {
    methods: {
        /**
         * Конвертирует объект [ключ]: значение в вид [{text: 'значение', value: 'ключ'}]
         * @param object
         * @param convertFirstLetter - Конвертировать первую букву значения в верхний регистр
         * @returns {unknown[]|boolean}
         */
        convertToOption(object, convertFirstLetter = false) {
            if (!object) {
                return false;
            }
            const keys = Object.keys(object);
            return keys.map((key) => {
                if (typeof object[key] === 'string') {
                    return {
                        value: key,
                        text: convertFirstLetter ? this.convertTextToCapitalize(object[key]) : object[key]
                    };
                }
                if (!object[key]) {
                    return null;
                }
                const valuesParse = this.convertToOption(object[key]);
                return {
                    text: convertFirstLetter ? this.convertTextToCapitalize(key) : key,
                    childNodes: valuesParse
                };
            })
                .filter((item) => item);
        },
        convertTextToCapitalize(text) {
            const textSymbols = text.split('');
            textSymbols[0] = textSymbols[0].toUpperCase();
            return textSymbols.join('');
        }
    },
};
